import { render, staticRenderFns } from "./CharUsersBar.vue?vue&type=template&id=f8aa058a&scoped=true&"
import script from "./CharUsersBar.vue?vue&type=script&lang=js&"
export * from "./CharUsersBar.vue?vue&type=script&lang=js&"
import style0 from "./CharUsersBar.vue?vue&type=style&index=0&id=f8aa058a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aa058a",
  null
  
)

export default component.exports